import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Arrow2 } from 'components/atoms/arrow2';
import { JaHeading as JaHeadingBase } from 'components/atoms/jaHeading';
import { Link } from 'gatsby';
import GatsbyLink from 'gatsby-link';
import { TweenMax } from 'gsap';
import React, { useEffect, useRef } from 'react';
import fonts from 'style/fonts';
import sizes from 'style/sizes';
import { baseTransitionSecond, mq } from 'style/variables';
import { ImgMask } from '../imgMask/index';

type TopicsCardProps = {
  to: string;
  imgpath: string;
  category: string;
  title: string;
  date: string;
  delay?: number;
  isEn?: boolean;
};

const Container = styled(Link)<Pick<TopicsCardProps, 'delay'>>`
  display: block;
  position: relative;
  ${props =>
    props.delay &&
    css`
      opacity: 0;
    `}
  ${mq.onlysp} {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const Texts = styled.div`
  position: relative;
  padding-top: 32px;

  ${mq.onlypc} {
    padding-bottom: 22px; // クリッカブルエリア担保のためにpadding-bottomをあえてつけている、organisms/TopicsGroupではこの高さを含めたマージンで計算
  }
`;

const Date = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-weight: 500;
  span {
    display: flex;
    align-items: flex-start;
    font-family: ${fonts.enGothic};
    font-size: 13px;
    line-height: 1;
    letter-spacing: 0.06em;
    margin-bottom: -0.2em;
    ${mq.onlysp} {
      letter-spacing: 0.06em;
    }
    &:first-of-type {
      &::after {
        content: '';
        display: block;
        width: 1px;
        height: 0.8em;
        margin: 0 ${sizes.margin[17]};
        background-color: #333333;
        ${mq.onlysp} {
          margin: 0 15px 0 13px;
        }
      }
    }
  }
`;

const JaHeading = styled(JaHeadingBase)<Pick<TopicsCardProps, 'isEn'>>`
  ${mq.onlysp} {
    ${({ isEn }) =>
      isEn &&
      css`
        line-height: 1.2em;
      `};
  }
`;

const Title = styled.div`
  [data-lang='en'] & {
    h4 {
      font-size: 16px;
    }
  }
`;

export const TopicsCard: React.FC<TopicsCardProps> = props => {
  const container = useRef<GatsbyLink<unknown>>(null);
  useEffect(() => {
    if (props.delay) {
      const delay = props.delay * 0.1 + baseTransitionSecond;
      TweenMax.to(container.current, baseTransitionSecond * 2, {
        opacity: 1,
        delay: delay,
      });
    }
  }, []);
  return (
    <Container to={props.to} ref={container} delay={props.delay}>
      <ImageWrapper>
        <ImgMask filename={props.imgpath} alt={props.title}></ImgMask>
        <Arrow2 />
      </ImageWrapper>
      <Texts>
        <Date>
          <span>{props.category}</span>
          <span>{props.date}</span>
        </Date>
        <Title>
          <JaHeading size={'demismall'} dangerouslySetInnerHTML={{ __html: props.title }} isEn={props.isEn} />
        </Title>
      </Texts>
    </Container>
  );
};
